/** Business identity and contact details used across metadata, schema and page copy. */
export const SITE = {
  name: "Freelancer Tamal",
  fullName: "Rahatul Ashiq Tamal",
  title: "Freelancer Tamal — SEO, AEO & GEO Expert, Bangladesh",
  url: "https://freelancertamal.com",
  description:
    "Senior SEO, AEO & GEO consultant in Rangpur, Bangladesh — helping local, SaaS & ecommerce brands grow organic visibility on Google and in AI answers like ChatGPT & AI Overviews.",
  email: "admin@freelancertamal.com",
  phone: "+8801777591051",
  city: "Rangpur",
  region: "Rangpur Division",
  country: "Bangladesh",
  countryCode: "BD",
  streetAddress: "House #152, Road #3, Mayamoyi Sorok, Kamal Kachna",
  postalCode: "5400",
  geo: { lat: 25.7439, lng: 89.2752 },
  /**
   * Scheduling link used by /book. Set `url` to a Cal.com or Google Calendar
   * appointment URL and the page embeds it; while it's empty the page falls
   * back to email / phone / WhatsApp so the CTA is never a dead end.
   */
  booking: {
    provider: "" as "" | "cal" | "google",
    url: "",
  },
  social: {
    linkedin: "https://www.linkedin.com/company/freelancer-tamal/",
    facebook: "https://www.facebook.com/freelancertamal/",
    youtube: "https://youtube.com/@freelancertamal",
    googleBusiness: "https://share.google/0wxWoHi4niDKQOFyH",
  },
};
